// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import SpeakingZone from "assets/images/images_new/microphone-icon.svg";
// import WritingZone from "assets/images/images_new/writing-icon.svg";
// import ReadingZone from "assets/images/images_new/reading-icon.svg";
// import ListeningZone from "assets/images/images_new/listening-icon.svg";
// import RightArrow from "assets/images/images_new/right-arrow.svg";
// import API from "api.js";
// import BookNowModal from "components/Dashboard/New/BookNowModal";
// import BuyNowClasses from "assets/images/images_new/buy_classes.png";
// import { useSelector, useDispatch } from "react-redux";
// export default function UpcomingClasses(props) {
//   const { classes, showInPopup, sessionAcessExpiry } = props;
//   const [loading, setLoading] = useState(true);
//   const [loadingCounter, setLoadingCounter] = useState(0);
//   const [sessionAccess, setSessionAccess] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);
//   const user = useSelector((state) => state.user);
//   const toggle = () => {
//     setIsOpen((prev) => !prev);
//   };
//   /**
//    * check classes.
//    */
//   useEffect(() => {
//     // counter is used to encounter the props update
//     if (loadingCounter > 0) {
//       setLoading(false);
//     }
//     console.log(".........");
//     setLoadingCounter((prev) => prev + 1);
//   }, [classes]);

//   /**
//    * check session expiry.
//    */
//   useEffect(() => {
//     if (
//       sessionAcessExpiry !== null ||
//       sessionAcessExpiry !== undefined ||
//       sessionAcessExpiry !== ""
//     ) {
//       console.log("sessionAcessExpiry", sessionAcessExpiry);
//       const today = new Date();
//       const expiry = new Date(sessionAcessExpiry);
//       console.log("expiry", expiry);

//       const status = today.getTime() < expiry.getTime() ? true : false;
//       console.log("status", status);
//       setSessionAccess(status);
//     }
//   }, [sessionAcessExpiry]);

//   return (
//     <>
//       {showInPopup ? (
//         <div className="plan-classes-wrapper">
//           <li className="title">Upcoming Classes</li>
//           <ul className="upcoming-classes">
//             {classes.slice(0, 5).map((item, i) => {
//               return (
//                 <li className="list-body" key={i}>
//                   <span className="first-col">
//                     <a
//                       href={item.link}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       data-toggle="tooltip"
//                       data-placement="left"
//                       title={item.title}
//                     >
//                       {item.title}
//                     </a>
//                   </span>
//                   <span>{item.time.split(" ")[1]}</span>
//                 </li>
//               );
//             })}

//             <li>
//               {classes.length > 5 ? (
//                 <Link to="/admin/session" className="sub-upgrade-btn">
//                   View All
//                 </Link>
//               ) : classes.length === 0 ? (
//                 <span>No Upcoming Classes</span>
//               ) : null}
//             </li>
//           </ul>
//         </div>
//       ) : (
//         <div className="dashobard-upcoming-classes">
//           <h2>Upcoming Classes</h2>

//           {loading ? (
//             <div className="gray-text">Loading...</div>
//           ) : (
//             <>
//               {!sessionAccess ? (
//                 // <DummyClasses />

//                 <ul>
//                   {classes.length === 0 && (
//                     <li className="speaking-list">
//                       <span className="left-text">
//                         No Upcoming Classes{" "}
//                         <span className="complexity-badge difficult">
//                           No Classes
//                         </span>
//                       </span>
//                     </li>
//                   )}

//                   {classes.slice(0, 5).map((item, i) => {
//                     return (
//                       <li className="speaking-list" key={i}>
//                         <span
//                           className="left-text adjust-width"
//                           data-toggle="tooltip"
//                           data-placement="left"
//                           title={item.title}
//                         >
//                           <span>{item.title}</span>
//                         </span>
//                         <span className="right-text">
//                           {item.time.split(" ")[1]}
//                         </span>



//                         {user?.session_type ? <a
//                           href={item.link}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="right-text"
//                         >
//                           Open <img src={RightArrow} alt="LA" />
//                         </a> :
//                           <a
//                             href="#"
//                             className="right-text"
//                             onClick={toggle}
//                           >
//                             Book Now <img src={RightArrow} alt="LA" />
//                           </a>}

//                       </li>
//                     );
//                   })}
//                   <BookNowModal isOpen={isOpen} toggle={toggle} />
//                   {classes.length > 5 && (
//                     <li className="speaking-list text-center justify-content-center">
//                       <Link to="/admin/session" className="sub-upgrade-btn">
//                         View All
//                       </Link>
//                     </li>
//                   )}
//                 </ul>
//               ) : (
//                 <ul>
//                   {classes.length === 0 && (
//                     <li className="speaking-list">
//                       <span className="left-text">
//                         No Upcoming Classes{" "}
//                         <span className="complexity-badge difficult">
//                           No Classes
//                         </span>
//                       </span>
//                     </li>
//                   )}

//                   {classes.slice(0, 5).map((item, i) => {
//                     return (
//                       <li className="speaking-list" key={i}>
//                         <span
//                           className="left-text adjust-width"
//                           data-toggle="tooltip"
//                           data-placement="left"
//                           title={item.title}
//                         >
//                           <span>{item.title}</span>
//                         </span>
//                         <span className="right-text">
//                           {item.time.split(" ")[1]}
//                         </span>
//                         {/* <a
//                           href={item.link}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="right-text"
//                         >
//                           Open <img src={RightArrow} alt="LA" />
//                         </a> */}
//                         <a
//                           href="#"
//                           className="right-text"
//                         >
//                           Open <img src={RightArrow} alt="LA" />
//                         </a>

//                         <BookNowModal isOpen={isOpen} toggle={toggle} />
//                       </li>
//                     );
//                   })}
//                   {classes.length > 5 && (
//                     <li className="speaking-list text-center justify-content-center">
//                       <Link to="/admin/session" className="sub-upgrade-btn">
//                         View All
//                       </Link>
//                     </li>
//                   )}
//                 </ul>
//               )}
//             </>
//           )}
//         </div>
//       )}
//     </>
//   );
// }

// const DummyClasses = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggle = () => {
//     setIsOpen((prev) => !prev);
//   };

//   return (
//     <>
//       <img
//         src={BuyNowClasses}
//         onClick={toggle}
//         className="cursor-pointer visibility-visible"
//       />

//       <BookNowModal isOpen={isOpen} toggle={toggle} />
//     </>
//   );
// };

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SpeakingZone from "assets/images/images_new/microphone-icon.svg";
import WritingZone from "assets/images/images_new/writing-icon.svg";
import ReadingZone from "assets/images/images_new/reading-icon.svg";
import ListeningZone from "assets/images/images_new/listening-icon.svg";
import RightArrow from "assets/images/images_new/right-arrow.svg";
import API from "api.js";
import BookNowModal from "components/Dashboard/New/BookNowModal";
import BuyNowClasses from "assets/images/images_new/buy_classes.png";
import { useSelector, useDispatch } from "react-redux";
import classIcon from "assets/images/upcoming-classes.svg";

export default function UpcomingClasses(props) {
  const { classes, showInPopup, sessionAcessExpiry } = props;
  const [loading, setLoading] = useState(true);
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [sessionAccess, setSessionAccess] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const toggle = () => {
    setIsOpen((prev) => !prev);
  };
  /**
   * check classes.
   */
  useEffect(() => {
    // counter is used to encounter the props update
    if (loadingCounter > 0) {
      setLoading(false);
    }
    console.log(".........");
    setLoadingCounter((prev) => prev + 1);
  }, [classes]);
  
    useEffect(()=>{
   if(classes.length > 0){
    setLoading(false);
   }
  },[classes])

  /**
   * check session expiry.
   */
  useEffect(() => {
    if (
      sessionAcessExpiry !== null ||
      sessionAcessExpiry !== undefined ||
      sessionAcessExpiry !== ""
    ) {
      console.log("sessionAcessExpiry", sessionAcessExpiry);
      const today = new Date();
      const expiry = new Date(sessionAcessExpiry);
      console.log("expiry", expiry);

      const status = today.getTime() < expiry.getTime() ? true : false;
      console.log("status", status);
      setSessionAccess(status);
    }
  }, [sessionAcessExpiry]);

  const formattedTime = (time) => {
   return time.slice(0, 5);
  } 

  return (
    <>
      {showInPopup ? (
        <div className="plan-classes-wrapper">
          <li className="title">Upcoming Classes</li>
          <ul className="upcoming-classes">
            {classes.slice(0, 5).map((item, i) => {
              return (
                <li className="list-body" key={i}>
                  <span className="first-col">
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-toggle="tooltip"
                      data-placement="left"
                      title={item.title}
                    >
                      {item.title}
                    </a>
                  </span>
                  <span>{item.time.split(" ")[1]}</span>
                </li>
              );
            })}

            <li>
              {classes.length > 5 ? (
                <Link to="/admin/session" className="sub-upgrade-btn FS12 fw-600" style={{color:"#94C23C"}}>
                  View All
                </Link>
              ) : classes.length === 0 ? (
                <span>No Upcoming Classes</span>
              ) : null}
            </li>
          </ul>
        </div>
      ) : (
        <div className="dashobard-upcoming-classes">
          <div className="d-flex justify-content-between align-items-center ">
            <h2>Upcoming Classes</h2>
           <Link to="/admin/session" className="link-style FS12 fw-600" style={{color:"#94C23C"}}>
                  View All
                </Link>
          </div>
          {loading ? (
            <div className="gray-text">Loading...</div>
          ) : (
            <>
              {!sessionAccess ? (
                // <DummyClasses />

                <ul>
                  {classes.length === 0 && (
                    <li className="speaking-list">
                      <span className="left-text">
                        No Upcoming Classes{" "}
                        <span className="complexity-badge difficult">
                          No Classes
                        </span>
                      </span>
                    </li>
                  )}

                  {/* {classes.slice(0, 5).map((item, i) => {
                    return (
                      <li className="speaking-list" key={i}>
                        <span
                          className="left-text adjust-width"
                          data-toggle="tooltip"
                          data-placement="left"
                          title={item.title}
                        >
                          <span>{item.title}</span>
                        </span>
                        <span className="right-text">
                          {item.time.split(" ")[1]}
                        </span>

                        {user?.session_type ? <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="right-text"
                        >
                          Open <img src={RightArrow} alt="LA" />
                        </a> :
                          <a
                            href="#"
                            className="right-text"
                            onClick={toggle}
                          >
                            Book Now <img src={RightArrow} alt="LA" />
                          </a>}

                      </li>
                    );
                  })} */}
                    {classes.slice(0, 5).map((item, i) => {
                    return (
                      <li className="speaking-list" key={i}>
                       <div className="d-flex align-items-center gap-2 flex-wrap speaking-content"
                       >
                         <img src={classIcon} alt="classes"/>
                        <span
                          className="left-text adjust-width mb-0"
                          // data-toggle="tooltip"
                          // data-placement="left"
                          title={item.title}
                        >
                          <span>{item.title}</span>
                        </span>
                        </div>
                        <div className="d-flex align-items-center gap-1 flex-wrap">
                           <span className="right-text">
                           { formattedTime(item.time.split(" ")[1])}
                          {/* {item.time.split(" ")[1]} */}
                        </span>

                        {user?.session_type ? <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="right-text book-now-link"
                          style={{width:"fit-content",padding:"5px 3px 5px 10px"}}
                        >
                          Open <img src={RightArrow} alt="LA" />
                        </a> :
                          <a
                            href="#"
                            className="right-text book-now-link"
                            onClick={toggle}
                            style={{width:"fit-content"}}
                          >
                            Book Now <img src={RightArrow} alt="LA" />
                          </a>}

                        </div>
                      </li>
                    );
                  })}
                  <BookNowModal isOpen={isOpen} toggle={toggle} />
                  {classes.length > 4 && (
                    <li className="speaking-list text-center justify-content-center">
                      <Link to="/admin/session" className="sub-upgrade-btn FS12 fw-600" style={{color:"#94C23C"}}>
                        View All
                      </Link>
                    </li>
                  )}
                </ul>
              ) : (
                <ul>
                  {classes.length === 0 && (
                    <li className="speaking-list">
                      <span className="left-text">
                        No Upcoming Classes{" "}
                        <span className="complexity-badge difficult">
                          No Classes
                        </span>
                      </span>
                    </li>
                  )}

                  {classes.slice(0, 5).map((item, i) => {
                    return (
                      <li className="speaking-list" key={i}>
                        <span
                          className="left-text adjust-width mb-0"
                          data-toggle="tooltip"
                          data-placement="left"
                          title={item.title}
                        >
                          <span>{item.title}</span>
                        </span>
                        <span className="right-text">
                          {item.time.split(" ")[1]}
                        </span>
                        <a
                          href="#"
                          className="right-text"
                        >
                          Open <img src={RightArrow} alt="LA" />
                        </a>

                        <BookNowModal isOpen={isOpen} toggle={toggle} />
                      </li>
                    );
                  })}
                  {classes.length > 4  && (
                    <li className="speaking-list text-center justify-content-center">
                      <Link to="/admin/session" className="sub-upgrade-btn FS12 fw-600" style={{color:"#94C23C"}}>
                        View All
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}

const DummyClasses = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <img
        src={BuyNowClasses}
        onClick={toggle}
        className="cursor-pointer visibility-visible"
      />

      <BookNowModal isOpen={isOpen} toggle={toggle} />
    </>
  );
};
